import { createFileRoute } from "@tanstack/react-router"

import StudioIndexPage from "~/components/studio/StudioIndexPage"

import { usePageTracking } from "../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/insights/studio/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Studio")
  return <StudioIndexPage />
}
